export const TOGGLE_EVENT_TYPE_FILTER_MENU = 'ibw/SearchEventType/TOGGLE_EVENT_TYPE_FILTER_MENU';
